// extracted by mini-css-extract-plugin
export default {"wrap":"Empty_wrap__SZE8o","large":"Empty_large__1T1to"};